import { render, staticRenderFns } from "./CourseAbout.vue?vue&type=template&id=3428c394&scoped=true&"
import script from "./CourseAbout.vue?vue&type=script&lang=js&"
export * from "./CourseAbout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3428c394",
  null
  
)

export default component.exports